import React, { ReactNode, useEffect, useRef } from "react";

import { TooltipPositionType } from "primereact/tooltip/tooltipoptions";
import { useTranslation } from "react-i18next";
import { Tooltip } from "primereact/tooltip";
import classNames from "classnames/dedupe";

import "./gt-tooltip.style.scss";

export type TooltipContentType = string | number | ReactNode | undefined | null;

interface GtTooltipProps {
    targetRef: React.RefObject<HTMLDivElement>;
    tooltipContent: TooltipContentType;
    className?: string;
    showTooltipDelay?: number;
    hideTooltipDelay?: number;
    placement?: TooltipPositionType;
    disableTranslation?: boolean;
}

export const GtTooltip = (props: GtTooltipProps) => {
    const { targetRef, tooltipContent, className, showTooltipDelay = 500, placement = "top", disableTranslation } = props;
    let ref = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        ref.current = targetRef.current;
    }, []);

    const { t } = useTranslation();

    if (!tooltipContent) return <></>;

    return (
        <Tooltip
            target={ref.current as HTMLDivElement}
            position={placement}
            className={classNames("gt-tooltip", className)}
            appendTo={document.body}
            showDelay={showTooltipDelay}
        >
            {!disableTranslation && typeof tooltipContent == "string" ? t(tooltipContent) : tooltipContent}
        </Tooltip>
    );
};

// export const GtTooltip = _GtTooltip;
